import { render, staticRenderFns } from "./RBox.vue?vue&type=template&id=1d8a0336&scoped=true&"
import script from "./RBox.vue?vue&type=script&lang=js&"
export * from "./RBox.vue?vue&type=script&lang=js&"
import style0 from "./RBox.vue?vue&type=style&index=0&id=1d8a0336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a0336",
  null
  
)

export default component.exports